import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (

<nav className="navbar">
  <div className="navbar-center">
    <ul className="nav-links">
      <li>
        <a href="#aboutme">About Me</a>
      </li>
      <li>
        <a href="#projects">Projects</a>
      </li>
      <li>
        <a href="#contact">Contact/Links</a>
      </li>
    </ul>
  </div>
</nav>
);
};

export default Navbar;